import {
  API_BASE_URL,
  apiGet,
  apiPost,
} from "./client.js";
import {
  authSessionResponseSchema,
  currentUserResponseSchema,
  type AuthSessionResponse,
  type CurrentUserResponse,
} from "@multi-chat/shared";

export async function getSession(signal?: AbortSignal): Promise<AuthSessionResponse> {
  return authSessionResponseSchema.parse(await apiGet("/auth/session", signal));
}

export async function getCurrentUser(signal?: AbortSignal): Promise<CurrentUserResponse> {
  return currentUserResponseSchema.parse(await apiGet("/me", signal));
}

/** Backend contract is `POST /auth/logout` → 204; it revokes the session and clears the cookie. */
export async function logout(signal?: AbortSignal): Promise<void> {
  await apiPost("/auth/logout", undefined, signal);
}

export function googleStartUrl(mode: "popup" | "redirect", returnPath?: string): string {
  const url = new URL(`${API_BASE_URL}/auth/google/start`);
  url.searchParams.set("mode", mode);
  if (returnPath) url.searchParams.set("returnPath", returnPath);
  return url.toString();
}
